import { ReactNode } from "react";
import { Box, Flex, Text } from "@mantine/core";
import { MapLayerPickerCard } from "./MapLayerPickerCard";

type MapLayerPickerPartProps = {
  title: string;
  children: ReactNode;
};

export const MapLayerPickerPart = ({
  title,
  children,
}: MapLayerPickerPartProps) => (
  <Box mb="md">
    <Text
      mb="xs"
      sx={(theme, u) => ({
        [u.dark]: {
          color: theme.colors.gray[0],
          textShadow: "0 0 6px #00000085",
        },
        [u.light]: {
          color: theme.colors.gray[9],
          textShadow: "0 0 6px #ffffff85",
        },
        fontSize: 22,
        fontWeight: "bold",
      })}
    >
      {title}
    </Text>
    {children}
  </Box>
);

export const Grid = ({ children }: { children: ReactNode }) => (
  <Flex
    mih={50}
    maw={900}
    gap="xs"
    justify="flex-start"
    align="flex-start"
    direction="row"
    wrap="wrap"
  >
    {children}
  </Flex>
);

MapLayerPickerPart.Card = MapLayerPickerCard;
MapLayerPickerPart.Grid = Grid;
